'use client';

import { Box, Button, Tooltip } from '@mui/material';
import React, { ReactElement } from 'react';

type Props = {
  children: ReactElement;
};

export const LimitedFreeTooltip: React.FC<Props> = ({ children }) => {
  return (
    <Tooltip
      title={'便利な機能を無料提供中！'}
      placement="top"
      arrow
      // NOTE: モバイルでタッチ時にすぐ表示するための設定
      // https://stackoverflow.com/questions/69030402/material-ui-tooltip-is-not-working-on-mobile
      enterTouchDelay={0}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                // NOTE: 表示の位置調整はオフセットを使って調整
                offset: [0, 0],
              },
            },
          ],
        },
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <Button
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
        />

        {children}
      </Box>
    </Tooltip>
  );
};
